import PostsList from './posts-list';
import { queryArgsAsMap, getUrlWithQueryArgs, getUrlQueryArg } from '../../util/url-util';

// function the pagination and the search options 
class PostsListBlog extends PostsList {
	constructor(el) {
		super(el);

		this.setEndpoint('wp/v2/posts');
		this.setCardContainerClasses('columns small-12 medium-6 large-4');

		this.formSearchEl = this.el.querySelector('form#form_filter_search');
		this.filterCategoryEl = this.el.querySelector('select#filter_category');
		this.filterTagEl = this.el.querySelector('select#filter_tag');

		this.filterCategorySlug = getUrlQueryArg('category', '');
		this.filterTagSlug = getUrlQueryArg('tag', '');
		this.filterSearch = getUrlQueryArg('search', '');

		if (this.loadMore) {
			this.loadMore.on('load', () => this.loadBlogPosts());
		}

		if (this.formSearchEl) {
			this.formSearchEl.addEventListener('submit', (e) => {
				e.preventDefault();

				const inputEl = e.currentTarget.querySelector('input');
				if (inputEl) {
					this.filterSearch = inputEl.value.trim();
					this.updateURL();
					this.clearCardsContainer();
					this.loadBlogPosts();
				}
			});

			const inputEl = this.formSearchEl.querySelector('input[type="search"], input');
			if (inputEl) {
				const maybeReset = async () => {
					if (inputEl.value.trim() === '' && this.filterSearch) {
						this.filterSearch = '';
						this.updateURL();
						this.clearCardsContainer();
						await this.loadBlogPosts(); 

						const pagination = this.el.querySelector('.posts-list__pagination');
						if (pagination && pagination.dataset.template) {
							pagination.innerHTML = pagination.dataset.template;
						}
					}
				};
				inputEl.addEventListener('search', maybeReset);
				inputEl.addEventListener('input', maybeReset);
			}
		}

		if (this.filterCategoryEl) {
			this.filterCategoryEl.addEventListener('change', (e) => {
				this.filterCategorySlug = e.currentTarget.value ?? '';
				this.updateURL();
				this.clearCardsContainer();
				this.loadBlogPosts();
			});
		}

		if (this.filterTagEl) {
			this.filterTagEl.addEventListener('change', (e) => {
				this.filterTagSlug = e.currentTarget.value ?? '';
				this.updateURL();
				this.clearCardsContainer();
				this.loadBlogPosts();
			});
		}
	}

	async loadBlogPosts(page = 1) {
		const config = {
			category: this.filterCategorySlug,
			tag: this.filterTagSlug,
			search: this.filterSearch,
			page
		};

		this.loadMorePosts(config);

		try {
			const apiRoot =
				(window && window.wpApiSettings && window.wpApiSettings.root)
					? window.wpApiSettings.root
					: '/wp-json/';

			const query = new URLSearchParams();

			if (this.filterCategorySlug) query.append('category', this.filterCategorySlug);
			if (this.filterTagSlug) query.append('tag', this.filterTagSlug);
			if (this.filterSearch) query.append('search', this.filterSearch);
			query.append('per_page', 12);
			query.append('page', page);

			const url = `${apiRoot}${this.endpoint}?${query.toString()}`;
			const res = await fetch(url, { credentials: 'same-origin' });

			if (res.ok) {
				const total = res.headers.get('X-WP-Total');
				const totalPages = parseInt(res.headers.get('X-WP-TotalPages') || '1', 10);
				console.log(`[Blog] Total results: ${total}, Pages: ${totalPages}`);

				const container = this.el.querySelector('.posts-list__cards-container');
				if (container) {
					container.dataset.totalPages = totalPages;
					container.dataset.currentPage = page;
				}

				this.updatePagination(totalPages, page);
			}
		} catch (err) {
			console.error('[Blog] Error fetching totals:', err);
		}
	}

	updatePagination(totalPages, currentPage = 1) {
		const paginationEl = this.el.querySelector('.posts-list__pagination');
		if (!paginationEl) return;

		paginationEl.innerHTML = '';

		if (totalPages <= 1) {
			paginationEl.classList.add('hide');
			return;
		}

		paginationEl.classList.remove('hide');

		const maxLinks = 5;
		let html = '<ul class="page-numbers">';

		// Prev
		if (currentPage > 1) {
			html += `<li><a class="prev page-numbers" data-page="${currentPage - 1}">« Prev</a></li>`;
		}

		let start = Math.max(1, currentPage - Math.floor(maxLinks / 2));
		let end = start + maxLinks - 1;
		if (end > totalPages) {
			end = totalPages;
			start = Math.max(1, end - maxLinks + 1);
		}

		if (start > 1) {
			html += `<li><a class="page-numbers" data-page="1">1</a></li>`;
			if (start > 2) html += `<li><span class="dots">…</span></li>`;
		}

		for (let i = start; i <= end; i++) {
			if (i === currentPage) {
				html += `<li><span class="page-numbers current">${i}</span></li>`;
			} else {
				html += `<li><a class="page-numbers" data-page="${i}">${i}</a></li>`;
			}
		}

		if (end < totalPages) {
			if (end < totalPages - 1) html += `<li><span class="dots">…</span></li>`;
			html += `<li><a class="page-numbers" data-page="${totalPages}">${totalPages}</a></li>`;
		}

		// Next
		if (currentPage < totalPages) {
			html += `<li><a class="next page-numbers" data-page="${currentPage + 1}">Next »</a></li>`;
		}

		html += '</ul>';
		paginationEl.innerHTML = html;

		paginationEl.querySelectorAll('a.page-numbers').forEach(a => {
			a.addEventListener('click', (e) => {
				e.preventDefault();
				const page = parseInt(a.dataset.page, 10);
				this.clearCardsContainer();
				this.loadBlogPosts(page);
			});
		});
	}


	updateURL() {
		const args = queryArgsAsMap();

		if (this.filterCategorySlug) {
			args.set('category', this.filterCategorySlug);
		} else {
			args.delete('category');
		}

		if (this.filterTagSlug) {
			args.set('tag', this.filterTagSlug);
		} else {
			args.delete('tag');
		}

		if (this.filterSearch) {
			args.set('search', this.filterSearch);
		} else {
			args.delete('search');
		}

		window.history.replaceState({}, '', getUrlWithQueryArgs(args));
	}
}

export default PostsListBlog;
